import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "@/pages/Dashboard";
import Tracker from "@/pages/Tracker";
import Finance from "@/pages/Finance";
import Reports from "@/pages/Reports";
import Billing from "@/pages/Billing";
import UsersAdmin from "@/pages/Users";
import Companies from "@/pages/Companies";
import Salary from "@/pages/Salary";
import DailyFollowup from "@/pages/DailyFollowup";
import Archive from "@/pages/Archive";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { ErrorLogPanel } from "@/components/ErrorLogPanel";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="tracker" element={<ProtectedRoute requirePerm="tracker"><Tracker /></ProtectedRoute>} />
              <Route path="daily" element={<ProtectedRoute requirePerm="daily"><DailyFollowup /></ProtectedRoute>} />
              <Route path="archive" element={<ProtectedRoute requirePerm="archive"><Archive /></ProtectedRoute>} />
              <Route
                path="finance"
                element={
                  <ProtectedRoute requirePerm="finance">
                    <Finance />
                  </ProtectedRoute>
                }
              />
              <Route
                path="reports"
                element={
                  <ProtectedRoute requirePerm="reports">
                    <Reports />
                  </ProtectedRoute>
                }
              />
              <Route
                path="billing"
                element={
                  <ProtectedRoute requirePerm="billing">
                    <Billing />
                  </ProtectedRoute>
                }
              />
              <Route
                path="users"
                element={
                  <ProtectedRoute requireOwner>
                    <UsersAdmin />
                  </ProtectedRoute>
                }
              />
              <Route
                path="salary"
                element={
                  <ProtectedRoute requirePerm="salary">
                    <Salary />
                  </ProtectedRoute>
                }
              />
              <Route
                path="companies"
                element={
                  <ProtectedRoute requireCompaniesAccess>
                    <Companies />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
        <ErrorLogPanel />
      </AuthProvider>
    </div>
  );
}

export default App;
